/* unplugin-vue-components disabled */import script from "./ability_copy.vue?vue&type=script&setup=true&lang=js"
export * from "./ability_copy.vue?vue&type=script&setup=true&lang=js"

import "./ability_copy.vue?vue&type=style&index=0&id=1d3a1659&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d3a1659"]])

export default __exports__